import { useEffect, useState } from 'react';
import useAxiosPrivate from './useAxiosPrivate';
import { apiAcceptance } from '../api/apiAcceptance.api';

export function useAcceptanceData(typeAcceptance) {
  const axiosPrivate = useAxiosPrivate();
  const [isLoading, setIsLoading] = useState(false);
  const [acceptance, setAcceptance] = useState(null);

  useEffect(() => {
    if (!typeAcceptance) return;

    setIsLoading(true);
    apiAcceptance
      .getAcceptanceDocumentByType(axiosPrivate, typeAcceptance)
      .then(setAcceptance)
      .finally(() => setIsLoading(false));
  }, [typeAcceptance]);

  const onAccept = async () => {
    if (!acceptance) return;
    setIsLoading(true);
    await apiAcceptance.acceptAcceptance(axiosPrivate, acceptance._id);
    setIsLoading(false);
  };

  return { acceptance, isLoading, onAccept };
}
